import ContentLoader from 'react-content-loader'
import { useTheme } from 'styled-components'

const StringLoader = () => {
    const theme = useTheme()
    return (
        <ContentLoader
            height={20}
            width={200}
            viewBox='0 0 200 20'
            backgroundColor={theme?.contentLoader.bgColor}
            foregroundColor={theme?.contentLoader.fgColor}
        >
            <rect x='0' y='0' rx='5' ry='5' width='200' height='20' />
        </ContentLoader>
    )
}

export default StringLoader
